<template>
  <div>
    <a-modal modal-id="link-contact" v-if="linkingXeroContact">
      <div slot="title">Link Xero Contact</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-3">Xero Contact:</div>
          <div class="col-lg-9">
            {{ linkingXeroContact.Name }}<br>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-3">Xero Client:</div>
          <div class="col-lg-9">
            <v-select
              :options="searchedClients"
              label="name"
              placeholder="Search Clients"
              @search="fetchClients"
              close-on-save="true"
              v-model="xeroClientLink"
            ></v-select>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-12">
            <button class="btn btn-primary btn-sm pull-right" @click="saveXeroContact"><i class="fa fa-link"></i> Link</button>
          </div>
        </div>
      </div>
    </a-modal>
    <in-wrapper>
      <in-ibox>
        <div slot="title">
          Invoices
          <router-link :to="`/admin/billing/invoices/new`" class="btn btn-primary btn-xs pull-right"><i class="fa fa-plus"></i> New Invoice</router-link>
        </div>
        <div slot="content" class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-2">
                <label for="">Status</label>
                <v-select :options="invoiceStatuses" v-model="filters.status" multiple="multiple" @input="loadInvoices"></v-select>
              </div>
              <div class="col-lg-2">
                <label for="">Clients</label>
                <v-select :options="filterData.clients" label="name" index="id" v-model="filters.clients" @input="loadInvoices" multiple="multiple"></v-select>
              </div>
              <div class="col-lg-2">
                <label for="">Department</label>
                <v-select :options="departments[0].Options" label="Name" index="TrackingOptionID" v-model="filters.departments" @input="loadInvoices" multiple="multiple" v-if="departments.length"></v-select>
              </div>
              <div class="col-lg-2">
                <label for="">Account</label>
                <v-select :options="accounts" label="Name" index="AccountID" v-model="filters.account" @input="loadInvoices" multiple="multiple"></v-select>
              </div>
              <div class="col-lg-2"></div>
            </div>
            <table class="table table-striped table-hover m-t-sm">
              <thead>
              <tr>
                <th>Date</th>
                <th>Number</th>
                <th>Client</th>
                <th>Ref</th>
                <th>Tracking</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="invoice in invoices" :key="invoice.id">
                <td>{{ invoice.invoice.DateString | aTime }}</td>
                <td><router-link :to="`/admin/billing/invoice/${invoice.id}`" :class="'status-'+ invoice.invoice.Status">{{ invoice.invoice.InvoiceNumber || 'No Number' }}</router-link></td>
                <td>
                  <span v-if="invoice.client"><router-link :to="''">{{ invoice.client.name }}</router-link></span>
                  <span v-else class="italic">
                    {{ invoice.invoice.Contact.Name }}
                    <i class="fa fa-plug pointer" v-tooltip="'Link Contact'" data-target="#link-contact" data-toggle="modal" @click="linkingXeroContact = invoice.invoice.Contact; xeroClientLink = null"></i>
                  </span>
                </td>
                <td>{{ invoice.invoice.Reference }}</td>
                <td>
                  <span class="label label-primary m-r-xs"
                        v-for="act in accounts.filter(a => invoice.invoice.LineItems.map(i => i.AccountCode).includes(a.Code))"
                        :key="'invoice-'+ invoice.id + '-' + act.Code"
                  >{{ act.Name }}</span>
                  <span class="label label-info m-r-xs"
                        v-for="(dept, index) in invoice.invoice.LineItems.map(i => i.Tracking).filter(i => i.length).map(i => i[0].Option).filter((it,p,s) => s.indexOf(it) === p)"
                        :key="'invoice-'+ invoice.id + '-' + dept + index"
                  >{{ dept }}</span>
                </td>
                <td>
                  <span v-if="invoice.invoice.Total === invoice.invoice.AmountPaid" class="green">{{ invoice.invoice.Total }} {{ invoice.invoice.CurrencyCode }}</span>
                  <span v-else-if="invoice.invoice.AmountPaid > 0" class="orange">{{ invoice.invoice.AmountPaid }} / {{ invoice.invoice.Total }} {{ invoice.invoice.CurrencyCode }}</span>
                  <span v-else class="red">{{ invoice.invoice.Total }} {{ invoice.invoice.CurrencyCode }}</span>
                </td>
                <td>{{ invoice.invoice.Status }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </in-ibox>
    </in-wrapper>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      invoices: [],
      filters: {
        status: [
          'DRAFT',
          'SUBMITTED',
          'AUTHORISED',
          'PAID'
        ],
        clients: [],
        departments: []
      },
      filterData: {
        clients: []
      },
      invoiceStatuses: [
        'DRAFT',
        'SUBMITTED',
        'AUTHORISED',
        'PAID',
        'DELETED',
        'VOIDED'
      ],
      linkingXeroContact: null,
      searchedClients: [],
      xeroClientLink: {}
    }
  },
  computed: {
    ...mapGetters({
      accounts: 'getXeroAccounts',
      departments: 'getXeroCategories'
    })
  },
  mounted () {
    this.loadInvoices()
    if (!this.accounts.length) {
      this.$store.dispatch('fetchXeroAccounts')
    }
    if (!this.departments.length) {
      this.$store.dispatch('fetchXeroCategories')
    }
    if (!this.filterData.clients.length) {
      this.loadClients()
    }
    document.title = 'Invoices :: PBN360 By Aphex Media'
  },
  methods: {
    async loadDepartments () {
      let departments = await axios.get(`/billing/xero/tracking-categories`)
      this.departments = departments.data
    },
    async loadInvoices () {
      try {
        let filters = new URLSearchParams(this.filters).toString()
        let invoices = await axios.get(`/integrations/xero/invoices?${filters}`)
        this.invoices = invoices.data
      } catch (e) {
        this.$toastr.error(e.data)
      }
    },
    async loadClients () {
      let clients = await axios.get(`/billing/xero/clients`)
      this.filterData.clients = clients.data
    },
    async fetchClients (search, loading) {
      if (search.length < 3) return
      loading(true)
      let contact = await axios.get(`/clients?operator=all&name=${search}`)
      loading(false)
      this.searchedClients = contact.data.data
    },
    async saveXeroContact () {
      try {
        await axios.patch(`/client/${this.xeroClientLink.id}`, {
          'customData.xeroContact': this.linkingXeroContact
        })
        this.$toastr.success('Contact successfully linked')
        $('#link-contact').modal('hide')
        this.xeroClientLink = {}
        this.linkingXeroContact = {}
        this.searchedClients = []
        await this.loadInvoices()
        await this.loadClients()
      } catch (e) {
      }
    }
  }
}
</script>
<style>
.italic {
  font-style: italic;
}
.status-DELETED, .status-VOIDED {
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Invoices.vue